import axios from 'axios'
import { getAPIService } from '../../../getServerHost'

export const taskDelete = async (payload: { id: number; type: string }) => {
  const { id, type } = payload
  const response = await axios.delete(`${getAPIService}/v2/api/cron-tasks/${type}/${id}`)
  return response.data
}
